export abstract class ColorGuidelines {
    public static readonly colorStack: Array<string> = ["#2d74ff", "#003396", "#08cde2", "#22d44c", "#f58331", "#7109b6",
        "#6d9eff ", "#da0368", "#04d2a1", "#ec4e4e ", "#069aaa", "#189836", "#d7620b", "#44056f", "#9c024b", "#03a17b",
        "#d71717", "#3e5172", "#fae800"];
}